import Carousel, { Props as CarouselProps } from 'components/Carousel';
import React from 'react';
import { Asserts } from 'yup';
import GeneralTile from 'components/tiles/GeneralTile';
import useAllMediaThumnails from 'src/hooks/queries/useAllMediaThumnails';
import { mediaBcCarouselSchema } from './schema';

const elementMap = {
  'media/bc-carousel': {
    component: Carousel,
    schema: mediaBcCarouselSchema,
    dataToProps: (
      data: Asserts<typeof mediaBcCarouselSchema>,
    ): CarouselProps => {
      // this still seems to be called correctly and is a perfomance opt
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const allMediaItems = useAllMediaThumnails();
      return {
        slidesPerPage: Math.min(data.slides.length, 3),
        slides: data.slides.map((slide) => {
          const image = allMediaItems.find(({ databaseId }) => (
            databaseId === slide.image.id
          ))?.localFile?.childImageSharp?.gatsbyImageData;
          return {
            id: slide.text + slide.title,
            content: (
              <GeneralTile
                title={slide.title}
                subtitle={slide.text}
                image={image}
              />
            ),
          };
        }),
      };
    },
  },
};

export default elementMap;
